import { create } from "zustand";

const useApartmentPathStore = create((set, get) => ({
  apartmentPath: null,

  setApartmentPath: (path) => set({ apartmentPath: path }),

  consumeApartmentPath: () => {
    const path = get().apartmentPath;
    set({ apartmentPath: null });
    return path;
  },

  resetApartmentPath: () => set({ apartmentPath: null }),
}));

export default useApartmentPathStore;
